import React, { useState } from "react";
import { Form, Input } from "antd";
import Swal from "sweetalert2";

import MobileLayout from "../../components/MobileLayout";
import { useAuth } from "../../hooks/auth";
import submitUserSuggestion from "../../services/userSuggestionService";

import { Body, Card, Lead, SubmitBtn } from "./styles";

const { TextArea } = Input;

const SuggestionSubmitPage: React.FC = () => {
  const { user } = useAuth();
  const [form] = Form.useForm();
  const [sending, setSending] = useState(false);

  const onFinish = async (values: { title: string; description: string }) => {
    if (!user?.uid) {
      Swal.fire({
        icon: "info",
        title: "Login necessário",
        text: "Entre na sua conta para enviar uma sugestão.",
      });
      return;
    }
    setSending(true);
    try {
      await submitUserSuggestion({
        userId: user.uid,
        email: user.email,
        title: values.title,
        description: values.description,
      });
      form.resetFields();
      await Swal.fire({
        icon: "success",
        title: "Obrigado!",
        text: "Sua sugestão foi enviada. Nossa equipe vai analisar.",
        timer: 2200,
        showConfirmButton: false,
      });
    } catch (e) {
      console.error(e);
      Swal.fire({
        icon: "error",
        title: "Erro ao enviar",
        text: "Tente novamente em instantes.",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <MobileLayout
      headerTitle="Enviar sugestão"
      headerType="private"
      headerDescription="Compartilhe um sinal ou melhoria para o sinalário"
    >
      <Body>
        <Card>
          <Lead>
            Descreva a palavra ou o sinal que gostaria de ver no aplicativo. Se
            possível, inclua contexto ou referência (sem conteúdo ofensivo).
          </Lead>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            requiredMark={false}
          >
            <Form.Item
              name="title"
              label="Título"
              rules={[
                { required: true, message: "Informe um título" },
                { min: 2, message: "Mínimo 2 caracteres" },
              ]}
            >
              <Input
                size="large"
                placeholder="Ex: Sinal para 'sustentabilidade'"
              />
            </Form.Item>
            <Form.Item
              name="description"
              label="Descrição"
              rules={[
                { required: true, message: "Descreva sua sugestão" },
                { min: 10, message: "Mínimo 10 caracteres" },
              ]}
            >
              <TextArea
                rows={5}
                placeholder="Explique o sinal, o uso da palavra ou anexe ideias de movimento."
              />
            </Form.Item>
            <SubmitBtn type="submit" disabled={sending || !user?.uid}>
              {sending ? "Enviando..." : "Enviar sugestão"}
            </SubmitBtn>
          </Form>
        </Card>
      </Body>
    </MobileLayout>
  );
};

export default SuggestionSubmitPage;
